export default {
  items: [
    /*
      {
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'icon-speedometer',
        badge: {
          variant: 'info',
          text: 'NEW',
        },
      },
      */
    {
      name: "Platform",
      icon: "icon-docs",
      url: "/platform",
      children: [
        {
          name: "Users",
          url: "/platform/users",
        },
      ],
    },
    {
      name: "Idea Web",
      icon: "icon-docs",
      url: "/idea",
      children: [
        {
          name: "Whitelist Requests",
          url: "/idea/whitelist",
        },
        {
          name: "Force Requests",
          url: "/idea/force",
        },
      ],
    },
    {
      name: "Game Categories",
      url: "/categories",
      icon: "icon-puzzle",
    },
    {
      name: "Game Modes",
      url: "/modes",
      icon: "icon-puzzle",
    },
    {
      name: "Game Mode Family",
      url: "/mode_family",
      icon: "icon-puzzle",
    },
    {
      name: "Game Highlight",
      url: "/highlight",
      icon: "icon-puzzle",
    },
    {
      name: "Game Templates",
      url: "/templates",
      icon: "icon-puzzle",
    },
    {
      name: "Games",
      url: "/games",
      icon: "icon-puzzle",
    },
    {
      name: "Development",
      icon: "icon-docs",
      url: "/development",
      children: [
        {
          name: "Budget",
          url: "/development/budget",
        },
        {
          name: "Role",
          url: "/development/role",
        },
        {
          name: "Skill Type",
          url: "/development/skill_type",
        },
        {
          name: "Skills",
          url: "/development/skills",
        },
        {
          name: "Game Developer",
          url: "/development/game_developer",
        },
        {
          name: "Developer",
          url: "/development/developer",
        },
      ],
    },
    {
      name: "NFTs - Heroes",
      icon: "icon-docs",
      url: "/nft",
      children: [
        {
          name: "Heroes - Batch",
          url: "/nft/heros_batch",
        },
        {
          name: "Heroes",
          url: "/nft/hero",
        },
        {
          name: "Variable Types",
          url: "/nft/variable_type",
        },
        {
          name: "Variable Items",
          url: "/nft/variable_items",
        },
        {
          name: "Weapons",
          url: "/nft/weapons",
        },
        {
          name: "Hero Actions",
          url: "/nft/hero_actions",
        },
        {
          name: "Rarity",
          url: "/nft/rarity",
        },
      ],
    },
    {
      name: "NFT Drops",
      url: "/nft_drops",
      icon: "icon-puzzle",
    },
    {
      name: "Item Categories",
      url: "/itemcategories",
      icon: "icon-puzzle",
    },
    {
      name: "Items",
      url: "/items",
      icon: "icon-puzzle",
    },
    {
      name: "Challenges",
      url: "/challenges",
      icon: "icon-puzzle",
    },
    {
      name: "Event",
      icon: "icon-docs",
      url: "/event",
      children: [
        {
          name: "Result",
          url: "/event/result",
        },
      ]
    }

    // {
    //   name: 'Tournaments',
    //   url: '/tournaments',
    //   icon: 'icon-puzzle',
    // },
    /*
    {
      name: "Game categories",
      url: "/categories",
      icon: "icon-puzzle",
    },
    {
      name: "Game modes",
      url: "/modes",
      icon: "icon-puzzle",
    },
    {
      name: "Games",
      url: "/games",
      icon: "icon-puzzle",
    },
    {
      name: "Development",
      icon: "icon-docs",
      url: "/development",
      children: [
        {
          name: "Budget",
          url: "/development/budget",
        },
        {
          name: "Role",
          url: "/development/role",
        },
        {
          name: "Skill Type",
          url: "/development/skill_type",
        },
        {
          name: "Skills",
          url: "/development/skills",
        },
        {
          name: "Game Developer",
          url: "/development/game_developer",
        },
        {
          name: "Developer",
          url: "/development/developer",
        },
      ],
    },
    /*
      {
        name: 'Tables',
        url: '/tables',
        icon: 'icon-puzzle',
      },
      {
        name: 'Players',
        url: '/players',
        icon: 'icon-puzzle',
      }, 
      */
    // {
    //   name: 'Members',
    //   url: '/members',
    //   icon: 'icon-puzzle',
    // }
  ],
};
